import { render, staticRenderFns } from "./TrackerTabsMobile.vue?vue&type=template&id=23bd87f1&scoped=true"
import script from "./TrackerTabsMobile.js?vue&type=script&lang=js&external"
export * from "./TrackerTabsMobile.js?vue&type=script&lang=js&external"
import style0 from "./TrackerTabsMobile.vue?vue&type=style&index=0&id=23bd87f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bd87f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBanner } from 'vuetify/lib/components/VBanner';
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBanner,VBtn,VIcon,VList,VListItem,VListItemAction,VListItemAvatar,VListItemTitle,VTextField})
